
import {request2} from "./request.js";
import { ProjectId } from "../common/const.js";
// 上传图片(p普通)
export function uploadImg(fd, IsCompressed, IsDownload,file) {
    // 是否压缩图片，接口默认的是true
    if (IsCompressed) {
        IsCompressed = `IsCompressed=false`
    } else {
        IsCompressed = `IsCompressed=false`
    }
    if (IsDownload) {
        IsDownload = `&IsDownload=true`
    } else {
        IsDownload = `&IsDownload=false`
    }
    if(file){
        file = `&directoryName=${file}`
    }else{
        file = ''
    }
    return request2({
        url: `/api2/TZsbAdminApi/Files/ImgUpload?${IsCompressed}${IsDownload}${file}`,
        method: "post",
        data: fd,
    });
}

// 上传图片（富文本编辑）
export function uploadForEditorImg(fd, IsCompressed, IsDownload,file) {
    // 是否压缩图片，接口默认的是true
    // if (IsCompressed == false) {
    //   IsCompressed = `IsCompressed=${IsCompressed}`
    // } else {
    //   IsCompressed = `IsCompressed=true`
    // }
    IsCompressed = `IsCompressed=false`;
    if (IsDownload == true) {
        IsDownload = `&IsDownload=${IsDownload}`;
    } else {
        IsDownload = `&IsDownload=false`;
    }
    
    if(file){
        file = `&directoryName=${file}`
    }else{
        file = ''
    }
 
    return request2({
        url: `/api2/TZsbAdminApi/Files/ImgUploadForEditor?${IsCompressed}${IsDownload}${file}`,
        method: "post",
        data: fd,
    });
}

// 上传文件
export function uploadFile(fd, IsUploadImg, IsDownload) {
    // 不限制上传类型，接口默认的是false
    if (IsUploadImg == true) {
        IsUploadImg = `IsUploadImg=${IsUploadImg}`;
    } else {
        IsUploadImg = `IsUploadImg=false`;
    }
    if (IsDownload == true) {
        IsDownload = `&IsDownload=${IsDownload}`;
    } else {
        IsDownload = `&IsDownload=false`;
    }
    return request2({
        url: `/api2/TZsbAdminApi/Files/FileUpload?${IsUploadImg}${IsDownload}`,
        method: "post",
        data: fd,
    });
}


// 删除文件
export function deleteFile(paths) {
    return request2({
        url: "/api2/TZsbAdminApi/Files/DeleteFile",
        method: "post",
        data: paths,
    });
}

// 老师作业附件上传
export function teacherUploadFile(fd,workFormat, IsCompressed, IsDownload) {
    // 不限制上传类型，接口默认的是false
    if (IsCompressed == true) {
        IsCompressed = `IsCompressed=${IsCompressed}`;
    } else {
        IsCompressed = `IsCompressed=false`;
    }
    if (IsDownload == true) {
        IsDownload = `&IsDownload=${IsDownload}`;
    } else {
        IsDownload = `&IsDownload=false`;
    }
    return request2({
        url: `/api2/TZsbAdminTeachApi/Common/AnnexUpload?workFormat=${workFormat}&${IsCompressed}${IsDownload}`,
        method: "post",
        data: fd,
    });
}
// 上传图片
export function AnnexUpload(fd,workFormat, IsCompressed, IsDownload) {
    // 不限制上传类型，接口默认的是false
    if (IsCompressed == true) {
        IsCompressed = `IsCompressed=${IsCompressed}`;
    } else {
        IsCompressed = `IsCompressed=false`;
    }
    if (IsDownload == true) {
        IsDownload = `&IsDownload=${IsDownload}`;
    } else {
        IsDownload = `&IsDownload=false`;
    }
    return request2({
        url: `/api2/TZsbTeacherTeachApi/TeacherFile/AnnexUpload?workFormat=${workFormat}&${IsCompressed}${IsDownload}`,
        method: "post",
        data: fd,
    });
}

// 删除作业附件
export function teacherDeleteFile(paths) {
    return request2({
        url: "/api2/TZsbAdminTeachApi/Common/DeleteFiles",
        method: "post",
        data: paths,
    });
}

//获取指定产品列表--用于关联产品与查阅关联的产品
export function getProductList(type, ids, keyWord, totalCount) {
    return request2({
        url: "/api2/TZsbAdminProductApi/CourseApi/GetCourses",
        method: "post",
        data: {
            keyWord: keyWord, //搜索关键字
            ids: ids, //指定产品iD集合
            types: type, //产品类型说明：1为面授课、2为网课、3为直播课
            pageSize: totalCount, //返回数目
        },
    });
}

//获取所有产品列表
export function getProductAllList(obj) {
    return request2({
        url: "/api2/TZsbAdminProductApi/Course/GetAllProduct",
        method: "post",
        data: obj,
    });
}

//获取产品下赠送产品列表
export function getProductMinList(id, productType) {
    return request2({
        url: "/api2/TZsbAdminProductApi/Course/GetProductMin",
        method: "get",
        params: {
            id: id,
            productType: productType,
        },
    });
}

//获取指定教师列表--用于关联教师与查阅教师
export function getTeacherList(ids, keyWord, totalCount) {
    return request2({
        url: "/api2/TZsbAdminTeachApi/AdminTeacher/AcquireTeacher",
        method: "post",
        data: {
            keyWord: keyWord, //搜索关键字
            ids: ids, //指定教师iD集合
            pageSize: totalCount, //返回数目
        },
    });
}

//获取指定教教材列表--关联、查阅
export function getTextbookList(ids, keyWord, totalCount) {
    return request2({
        url: "/api2/TZsbAdminTeachApi/Textbook/AcquireTextbook",
        method: "post",
        data: {
            keyWord: keyWord, //搜索关键字
            ids: ids, //指定iD集合
            pageSize: totalCount, //返回数目
        },
    });
}
export function getTextbookList1(ids, keyWord, totalCount) {
    return request2({
        url: "/api2/TZsbAdminTeachApi/Textbook/AcquireTextbook",
        method: "post",
        data: {
            keyWord: keyWord, //搜索关键字
            ids: ids, //指定iD集合
            pageSize: totalCount, //返回数目
        },
    });
}
//获取同类型课程列表
export function getTypeAllCourses(obj) {
    return request2({
        url: "/api2/TZsbAdminProductApi/CourseApi/GetCourses",
        method: "post",
        data: obj,
    });
}

//获取不同类型课程列表 版本2
export function getAllCourses(obj) {
    return request2({
        url: "/api2/TZsbAdminProductApi/CourseApi/GetCourses",
        method: "post",
        data: obj,
    });
}

//获取指定管理员
export function getEducationList(ids, type, keyWord, totalCount) {
    return request2({
        url: "/api7/InternalAffairsTeacherAdminApi/AdminRoles/GetAdminRolesHeaders",
        method: "post",
        data: {
            keyWord: keyWord, //搜索关键字
            ids: ids, //指定iD集合
            adminTypeIds: type, //管理员类别
            pageSize: totalCount, //返回数目
            project: ProjectId //项目Id
        },
    });
}

// 获取投放的客户端类型 /TZsbAdminApi/Article/GetClients
export function GetClients() {
    return request2({
        url: "/api2/TZsbAdminApi/Article/GetClients",
        method: "get",
    });
}

// 获取对应页面的操作按钮 /InternalAffairsTeacherAdminApi/TheMenu/GetTheMenuButtons
export function GetTheMenuButtons(menuId,isAuthorize,studentPageId) {
    return request2({
        url: "/api7/SBCenterAdminApi/TheMenu/GetTheMenuButtons",
        method: "get",
        params: {
            theMenuId: menuId,
            isAuthorize: isAuthorize,
            studentPageId:studentPageId,
            project: ProjectId //项目Id
        },
    });
}

// 获取指定类型划分下的所有类型数据 /TZsbAdminStudentApi/Category/GetCatetListByType
export function GetCatetListByType(typeId) {
    return request2({
        url: "/api2/TZsbAdminStudentApi/Category/GetCatetListByType",
        method: "get",
        params: {
            id: typeId,
        }
    });
}

// 今日寄语列表 /TZsbAdminTeachApi/AdminTodayMessage/GetList
export  function GetMessageList() {
    return request2({
        url: "/api2/TZsbAdminTeachApi/AdminTodayMessage/GetList",
        method: "get",
        data: {}
    });
}

// 基于类别获取类别下标签 /TZsbAdminStudentApi/KeywordTagAdmin/GetTagListByType
export function GetTagListByType(type) {
    return request2({
        url: "/api2/TZsbAdminStudentApi/KeywordTagAdmin/GetTagListByType",
        method: "get",
        params: {
            type: type,
        }
    });
}

// 获取老师接口 /InternalAffairsTeacherAdminApi/AdminRoles/GetAdminRolesHeaders
export function PublicAdminList(data, IsContain=true) {
    let idsParams = ''
    let typeParams = ''
    if(data.ids.length) {
        data.ids.forEach((id, index) => {
            if(index === data.ids.length - 1) {
                idsParams += `ids=${id}`
            } else {
                idsParams += `ids=${id}&`
            }
        });
    }
    if (data.adminTypeIds.length) {
        data.adminTypeIds.forEach((id, index) => {
            if(index === data.adminTypeIds.length - 1) {
                typeParams += `RoleIds=${id}`
            } else {
                typeParams += `RoleIds=${id}&`
            }
        });
    }
    return request2({
        url: `/api7/InternalAffairsTeacherAdminApi/AdminRoles/GetAdminRolesHeaders`,
        method: "post",
        data: {
            pageSize: 50,
            keyWord: data.keyWord,
            ids: data.ids,
            adminTypeIds: data.adminTypeIds,
            project: ProjectId
        }
    })
}
export function PublicAdminListOnline(data) {
    let idsParams = ''
    let typeParams = ''
    if(data.ids.length) {
        data.ids.forEach((id, index) => {
            if(index === data.ids.length - 1) {
                idsParams += `ids=${id}`
            } else {
                idsParams += `ids=${id}&`
            }
        });
    }
    if (data.adminTypeIds.length) {
        data.adminTypeIds.forEach((id, index) => {
            if(index === data.adminTypeIds.length - 1) {
                typeParams += `RoleIds=${id}`
            } else {
                typeParams += `RoleIds=${id}&`
            }
        });
    }
    return request2({
        url: `/api7/SBCenterAdminApi/AdminRelevance/GetAdminRolesHeaders`,
        method: "post",
        data: {
            pageSize: 50,
            keyWord: data.keyWord,
            ids: data.ids,
            adminTypeIds: data.adminTypeIds,
            project: ProjectId
        }
    })
}
// /TZsbAdminFocuseApi/Admins/GetAdminList 查询招生老师列表--添加、编辑学员分配招生老师使用
export function GetAdminList(data) {
    let idsParams = ''
    if(data.TeacherIds&&data.TeacherIds.length) {
        data.TeacherIds.forEach((id, index) => {
            if(index === data.TeacherIds.length - 1) {
                idsParams += `TeacherIds=${id}`
            } else {
                idsParams += `TeacherIds=${id}&`
            }
        });
    }
    if(data.AdminRole==undefined){
        data.AdminRole = ''
    }
    return request2({
        url: `/api2/TZsbAdminFocuseApi/Admins/GetAdminList?AdminRole=${data.AdminRole}&Name=${data.Name}&WorkState=${data.WorkState}&OrderByAsc=${data.OrderByAsc}&${idsParams}`,
        method: "get",
        data: {}
    });
}

export function CorrectingWork(data) {
    return request2({
        url: "/api2/TZsbTeacherTeachApi/TeacherWorkStudent/CorrectingWork",
        method: "post",
        data: data
    });
}
export function downFile(url) {
    return request2({
        url:url,
        method: 'get',
        responseType:'blob'
    })
}

// 保利威视上传图片接口
export function LiveRoomUploadImg(fd, type) {
    return request2({
        url: `/api2/TZsbAdminTeachApi/LiveRoom/UploadImagea?type=${type}`,
        method: "post",
        data: fd,
    });
}
// 空的后台列表页数据导出的权限校验接口
export function RecordExport(data) {
    return request2({
        url: "/api2/TZsbAdminApi/AdminDataChangeRecord/Export",
        method: "post",
        data: data
    });
}

// 导出数据文件的存储接口 
export function AppendAdminDataChangeRecord(data) {
    return request2({
        url: "/api2/TZsbAdminApi/AdminDataChangeRecord/AppendAdminDataChangeRecord",
        method: "post",
        data: data
    });
}


